import { uuid4 } from './misc.js';

function generateTraceId() {
  return uuid4();
}
function generateSpanId() {
  return uuid4().substring(16);
}

export { generateSpanId, generateTraceId };
//# sourceMappingURL=propagationContext.js.map
